import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoEquipe } from '../models/projeto-equipe.model';

@Injectable()
export class ProjetoEquipeCapacidadeExecucaoService extends BaseService<ProjetoEquipe> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-equipe';
  }

  public updateCapacidade(
    obj: ProjetoEquipe,
    id: number
  ): Observable<ProjetoEquipe> {
    return this.http.put<ProjetoEquipe>(
      this.baseUrl + '/capacidade/' + id,
      obj,
      { headers: this.headers }
    );
  }

  public getResponsabilidadesList(): Observable<[]> {
    return this.http.get<[]>(this.baseUrl + '/responsabilidades-list', {
      headers: this.headers,
    });
  }
}
